import React, { FC, useCallback } from "react"

import { CrowdSwitch } from "../../../../../../../Collaborators/Switch/Switch"
import { FormFieldsWhoShouldLabel } from "../FormFields"

interface WhoShouldLabelProps {
    isSysAdmin: boolean
    value: FormFieldsWhoShouldLabel
    onChange: (value: { whoShouldLabel: FormFieldsWhoShouldLabel }) => void
}

export const WhoShouldLabel: FC<WhoShouldLabelProps> = ({
    isSysAdmin,
    value,
    onChange
}) => {
    const handleChangeCanoticCrowd = useCallback(
        () =>
            onChange({
                whoShouldLabel: {
                    ...value,
                    isCanoticCrowd: !value.isCanoticCrowd
                }
            }),
        [onChange, value]
    )
    /**
    const handleChangeVisible = useCallback(
        () =>
            onChange({
                ...value,
                isVisible: !value.isVisible
            }),
        [onChange, value]
    )
     */

    return (
        <>
            <CrowdSwitch
                isCrowdActive={value.isCanoticCrowd}
                toggleCrowdActive={handleChangeCanoticCrowd}
            />
            {/* TODO: need endpoint
            {isSysAdmin ? (
                <Checkbox
                    variant="modern"
                    className="ml-7 pt-1"
                    label="Hide collaborators option from customer"
                    isChecked={!value.isVisible}
                    onChange={handleChangeVisible}
                />
            ) : null}
            */}
        </>
    )
}
